import analytics from '@mobi/libraries/analytics'
import GA from 'utils/GA'
import './Checkbox.scss'

const Checkbox = ({
  onChange,
  id,
  checked,
  dataTest,
  tracking,
  ariaLabel,
  group,
  index,
}) => {
  const handleChange = (ev) => {
    GA.customEvent('buttonClick', {
      id: ev.currentTarget.dataset.unique,
      text: tracking.text,
    })

    const indexString = index
    const indexArray = indexString.split('-')
    const indexAfterHyphen = indexArray[1]

    analytics.track('productAdded', {
      productId: id,
      brand: group?.name,
      category: 'Debt',
      location: 'LIST',
      position: Number(indexAfterHyphen),
      price: group?.inCash?.valueRaw,
      text: group?.name,
      variant: !checked ? 'ADDED' : 'REMOVED',
    })

    onChange(ev)
  }

  return (
    <>
      <div key={id}>
        <label htmlFor="" className="checkbox bounce">
          <input
            type="checkbox"
            checked={checked}
            data-unique={tracking.dataUnique}
            data-contrast="checkbox-contrast"
            onChange={handleChange}
            id={id}
            aria-label={ariaLabel}
            data-test={dataTest}
          />
          <svg viewBox="0 0 21 21">
            <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
          </svg>
        </label>
      </div>
    </>
  )
}

export default Checkbox
